import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    <MKTypography variant="h2" mb={3} color="dark">
                        Servicii de curățenie în weekend pentru firme și spații comerciale
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Programul aglomerat al unei firme lasă rareori loc pentru o curățenie temeinică fără să întrerupă lucrul. Doral Cleaning poate programa anumite intervenții în weekend, în funcție de tipul spațiului, de operațiunile necesare, de accesul disponibil și de programul echipei.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Avantajul principal al serviciilor de curățenie în weekend este simplu: lucrările se pot desfășura când spațiul este liber sau mult mai puțin utilizat, astfel încât activitatea companiei să fie perturbată cât mai puțin. Intervenția poate fi punctuală sau parte dintr-un program recurent, stabilit după evaluarea locației.
                    </MKTypography>

                    {/* Banner evaluare */}
                    <MKBox
                        sx={{
                            backgroundColor: "#e9f5f3",
                            borderLeft: "4px solid #0f766e",
                            p: 3,
                            borderRadius: "0 8px 8px 0",
                            mb: 4,
                        }}
                    >
                        <MKTypography variant="body1" color="dark" fontWeight="bold">
                            Solicită o evaluare gratuită{" "}
                            <span style={{ fontWeight: "normal" }}>
                                și spune-ne ce interval ai disponibil pentru intervenție.
                            </span>
                        </MKTypography>
                    </MKBox>

                    {/* Imagine Principală */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/d05bPW3Z/image-17.jpg"
                        alt="Servicii de curățenie în weekend pentru firme și spații comerciale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Sectiune: De ce sa programezi */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        De ce să programezi curățenia firmei în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Cel mai important câștig nu ține de lista de operațiuni, ci de momentul în care acestea se execută. Un interval cu trafic redus schimbă complet felul în care decurge o intervenție de curățenie într-un spațiu de firmă.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Activitatea companiei este perturbată mai puțin
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Fără aspiratoare și utilaje pornite în timpul ședințelor, fără blocarea temporară a zonelor intens circulate și cu mult mai puține interacțiuni între echipa de curățenie, angajați, clienți sau vizitatori. Ziua de lucru rămâne a ta, iar curățenia se întâmplă în fundal.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Echipa are acces mai ușor la suprafețele de lucru
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Sălile de ședință, birourile, recepția, zonele comune, grupurile sanitare, pardoselile, vitrinele sau compartimentările vitrate pot fi greu accesibile în timpul programului. Când spațiul este liber, echipa ajunge la toate aceste zone fără să întrerupă pe nimeni.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Spațiul este pregătit pentru reluarea activității
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Intervenția se programează astfel încât spațiul să fie curat și pregătit înaintea următoarei perioade de activitate, fără ca lucrările să afecteze programul obișnuit al companiei.
                    </MKTypography>

                    {/* Sectiune: Pentru ce tipuri de spatii */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Pentru ce tipuri de spații este potrivită curățenia în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Programarea se stabilește după activitatea efectivă din locație, nivelul de trafic, accesul disponibil și tipul de lucrări necesare.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Birouri și sedii de firmă
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Un interval de weekend ajută mai ales la{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-birouri-firme-spatii-comerciale"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățenia birourilor, firmelor și spațiilor comerciale
                        </a>
                        , unde se pot acoperi mai ușor:
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={3}>
                        <MKBox component="li" color="text" mb={1}>
                            open space, birouri individuale și săli de ședință;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            recepții, bucătării și zone comune;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            grupuri sanitare și spații administrative.
                        </MKBox>
                    </MKBox>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Showroom-uri și spații comerciale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Intervalul pentru{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-showroom"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățenia showroom-urilor
                        </a>{" "}
                        se stabilește în funcție de programul real al locației și de momentele în care anumite zone pot fi eliberate pentru intervenție.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Clinici, săli de fitness și spații educaționale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Pentru clinici, săli de fitness sau spații educaționale, intervenția se stabilește în funcție de specificul locației și de operațiunile necesare.
                    </MKTypography>

                    {/* Imagine Secundara 1 */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/tPs62tHk/image-18.jpg"
                        alt="Spații în care poate fi programată curățenia profesională în weekend"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Sectiune: Ce servicii pot fi programate */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Ce servicii pot fi programate în weekend?
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățenie generală
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        O{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-generala"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățenie generală profesională
                        </a>{" "}
                        este potrivită pentru intervenții mai ample, atunci când este util accesul liber la cât mai multe zone ale spațiului deodată.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățenie de întreținere
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Pentru companiile care vor un program recurent,{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-de-intretinere"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățenia de întreținere
                        </a>{" "}
                        stabilește frecvențe și operațiuni în funcție de nevoile locației.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățarea mochetelor și covoarelor
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Este exemplul cel mai potrivit pentru un interval fără trafic:{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-mochete"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățarea profesională a mochetelor
                        </a>{" "}
                        la sediul firmei poate fi planificată în afara programului sau în weekend, tocmai pentru a lăsa textilele să se usuce înainte de reluarea activității.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățarea pardoselilor și lucrări mecanizate
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Anumite operațiuni mecanizate sunt mult mai ușor de organizat când suprafața nu este circulată, fără a bloca zonele intens folosite în timpul programului.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățarea geamurilor și suprafețelor vitrate
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Relevantă pentru sedii, showroom-uri, vitrine și compartimentări vitrate,{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-geamuri-suprafete-vitrate"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            curățarea geamurilor și suprafețelor vitrate
                        </a>{" "}
                        contribuie direct la imaginea firmei.
                    </MKTypography>

                    {/* Imagine Secundara 2 */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/gbh6Xx4S/image-19.jpg"
                        alt="Curățare mecanizată programată în weekend într-un spațiu de birouri"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Cum stabilim programul */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Cum stabilim programul unei intervenții de curățenie în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Programarea trece prin patru pași simpli, gândiți astfel încât ordinea să fie clară:
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        1. Evaluarea spațiului
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Analizăm suprafața, tipul de spațiu, gradul de utilizare, materialele și zonele prioritare.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        2. Stabilirea operațiunilor
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Stabilim ce intră în intervenție — întreținere, curățenie generală, servicii mecanizate sau lucrări punctuale.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        3. Stabilirea accesului și a intervalului
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Se stabilesc intervalul de lucru, persoana de contact și modalitatea de acces în spațiu.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        4. Oferta personalizată
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Oferta se stabilește în funcție de suprafață, operațiuni, frecvență și resurse; pentru referință, poți consulta și{" "}
                        <a
                            href="https://doral-cleaning.ro/tarife"
                            style={{ textDecoration: "none", color: "#1A73E8", fontWeight: "bold" }}
                        >
                            tarifele serviciilor de curățenie
                        </a>
                        .
                    </MKTypography>

                    {/* Punctual sau recurent */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Intervenție punctuală sau program recurent în weekend?
                    </MKTypography>
                    <MKTypography variant="h4" mb={1} color="dark">
                        Intervenție punctuală
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={3}>
                        <MKBox component="li" color="text" mb={1}>
                            curățenie generală sau lucrări periodice mai ample;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            curățarea mochetei, a pardoselilor sau a geamurilor;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            curățenie după un eveniment, o lansare sau o conferință;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            pregătirea locației înaintea unei perioade aglomerate.
                        </MKBox>
                    </MKBox>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Program recurent
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Pentru companiile care au nevoie constant de intervenții atunci când spațiul este mai puțin utilizat. Frecvența poate fi săptămânală sau stabilită printr-un grafic personalizat.
                    </MKTypography>

                    {/* Informatii ofertare */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Ce informații ne ajută pentru ofertare?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Cu aceste detalii estimăm corect timpul, echipa și echipamentele necesare:
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={4}>
                        <MKBox component="li" color="text" mb={1}>
                            suprafața aproximativă și numărul de încăperi sau zone;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            tipul spațiului: birou, showroom, spațiu comercial, clinică etc.;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            serviciile dorite: curățenie generală, întreținere, mochete, pardoseli, geamuri;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            frecvența: intervenție punctuală sau program recurent;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            intervalul de weekend disponibil și modalitatea de acces în spațiu.
                        </MKBox>
                    </MKBox>

                    {/* De ce Doral Cleaning */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        De ce Doral Cleaning?
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={4}>
                        <MKBox component="li" color="text" mb={1}>
                            experiență îndelungată în curățenie profesională;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            personal verificat, instruit și supervizat;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            echipamente moderne și soluții profesionale;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            flexibilitate în adaptarea la programul și nevoile clientului;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            oferte clare și soluții personalizate;
                        </MKBox>
                        <MKBox component="li" color="text" mb={1}>
                            evaluare gratuită înainte de ofertare.
                        </MKBox>
                    </MKBox>

                    {/* Sectiune FAQ */}
                    <MKTypography variant="h3" mt={2} mb={2} color="dark">
                        Întrebări frecvente despre curățenia în weekend
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Curățenia în weekend este disponibilă pentru orice tip de firmă?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Depinde de tipul spațiului, de operațiunile necesare, de acces și de disponibilitatea echipei. Intervenția potrivită se stabilește după o evaluare a locației.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Ce intervale pot fi programate în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Doral confirmă intervalul potrivit în funcție de programul locației, de tipul lucrării și de disponibilitatea echipei.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Se poate face curățenie când sediul este gol?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Poate fi o opțiune, dacă modalitatea de acces și responsabilitățile sunt stabilite în prealabil.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Ce servicii pot fi efectuate în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Curățenie generală, curățenie de întreținere, curățarea mochetelor, a pardoselilor sau a suprafețelor vitrate, în funcție de cerințe.
                    </MKTypography>

                    <MKTypography variant="h4" mb={1} color="dark">
                        Cât costă curățenia în weekend?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Oferta se stabilește după evaluarea spațiului, a serviciilor, a frecvenței și a resurselor necesare.
                    </MKTypography>

                    {/* CTA Final */}
                    <MKBox
                        sx={{
                            background: "linear-gradient(135deg, #0f766e 0%, #115e56 100%)",
                            color: "white",
                            borderRadius: "12px",
                            p: 4,
                            mt: 4,
                            textAlign: "center",
                        }}
                    >
                        <MKTypography variant="h3" color="white" mb={2}>
                            Programează curățenia firmei într-un interval care îți încurcă cât mai puțin activitatea
                        </MKTypography>
                        <MKTypography variant="body1" color="white" mb={3} sx={{ opacity: 0.9 }}>
                            Spune-ne tipul spațiului, suprafața aproximativă, serviciile dorite și intervalul pe care îl ai disponibil. Echipa Doral evaluează cerințele și îți propune varianta de intervenție potrivită, fără să-ți întrerupă lucrul.
                        </MKTypography>
                        <MKBox display="flex" justifyContent="center" gap={2} flexWrap="wrap">
                            <MKBox
                                component="a"
                                href="https://doral-cleaning.ro/contact-curatenie"
                                sx={{
                                    backgroundColor: "#ffffff",
                                    color: "#0f766e",
                                    fontWeight: "bold",
                                    px: 3,
                                    py: 1.5,
                                    borderRadius: "6px",
                                    textDecoration: "none",
                                }}
                            >
                                Solicită o evaluare gratuită
                            </MKBox>
                            <MKBox
                                component="a"
                                href="tel:+40730407322"
                                sx={{
                                    backgroundColor: "transparent",
                                    color: "#ffffff",
                                    border: "2px solid #ffffff",
                                    fontWeight: "bold",
                                    px: 3,
                                    py: 1.5,
                                    borderRadius: "6px",
                                    textDecoration: "none",
                                }}
                            >
                                Cere o ofertă pentru curățenie în weekend
                            </MKBox>
                        </MKBox>
                    </MKBox>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
